import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';

var SideNavSection = function SideNavSection(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

SideNavSection.propTypes = {
  children: PropTypes.node.isRequired
};
process.env.NODE_ENV !== "production" ? SideNavSection.displayName = 'SideNavSection' : void 0;
var SideNavSection$1 = SideNavSection;

export { SideNavSection$1 as default };
